import { render, staticRenderFns } from "./LoginWithoutIcon.vue?vue&type=template&id=2fde0c8a&scoped=true&"
import script from "./LoginWithoutIcon.vue?vue&type=script&lang=ts&"
export * from "./LoginWithoutIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fde0c8a",
  null
  
)

export default component.exports